import { RuleId, RuleLevel } from '../../../types-v2';
import { areLanguageCodesEquivalent } from './normalize-language-code';
const NOT_CLASSIFIED_LANGUAGE = 'not classified';
export const siteLanguageRule = {
  checker: _ref => {
    let {
      detectedLanguage,
      settingsLanguage,
      isMultilingualEnabled,
      isManuallyCompleted
    } = _ref;
    return {
      status: isManuallyCompleted || isMultilingualEnabled || !detectedLanguage || detectedLanguage === NOT_CLASSIFIED_LANGUAGE || areLanguageCodesEquivalent(settingsLanguage, detectedLanguage) ? 'passed' : 'failed'
    };
  },
  level: RuleLevel.Site,
  ruleId: RuleId.SITE_LANGUAGE
};
//# sourceMappingURL=site-language.js.map